import React, { useEffect } from 'react';
// import styled from 'styled-components';
import { extractQueryParamValues } from '../js/utilities';
import AppService, { Utilities } from 's2s-app-service';
import Loading from "../components/loading";

const Connect = ()=>{
  useEffect(() => {
    // extract access_tokens, device_id and identityData from query params
    const qParams = extractQueryParamValues(window.location.search);

    // base64 decode and parse the access_tokens
    let access_tokens = JSON.parse(new Buffer.from(qParams.access_tokens, 'base64'));
    
    // call action to kick of connect to wsg
    try {
      const doConnect = async () => {
        //console.error("connecting....");
        await AppService.getInstance().connect(access_tokens, qParams.device_id);
        //console.error("done connecting...");
      };
      doConnect();
    } catch (e){
      console.error('error with voicemail: ', Utilities.formatError(e));
    }
    
  }, []);

  return (
    <div className="connectRoute">
      <Loading />
    </div >
  );
}; 
export default Connect;
